<template>
  <v-sheet class="about-section" color="accent">
    <LoadingWidget v-if="loading" />
    <v-container v-if="!loading && about.title">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <div
            class="
              text-h3 text-sm-h2 text-md-h1
              primary--text
              text--lighten-1
              d-flex
              justify-center
            "
          >
            <span class="about-section-title">{{ about.title }}</span>
          </div>
          <iframe
            class="about-section-video mt-2"
            :src="`https://www.youtube.com/embed/${getYoutubeCode(
              about.video
            )}`"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
          <div class="ck-content mt-8" v-html="about.text"></div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { getYoutubeCode } from "../../../utils/getYoutubeCode";
import LoadingWidget from "../../widgets/LoadingWidget.vue";

const _config = {
  mod: "attitudes-award-about",
};
export default {
  data: () => ({
    loading: true,
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    about() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
  components: { LoadingWidget },
};
</script>

<style lang="scss" scoped>
.about-section {
  padding-top: 96px;
  @media (max-width: 1264px) {
    padding-top: 64px;
  }
  @media (max-width: 960px) {
    padding-top: 48px;
  }
  @media (max-width: 600px) {
    padding-top: 32px;
  }
  &-title {
    font-family: "Get Show", cursive !important;
  }
  &-video {
    background-color: #000;
    display: block;
    aspect-ratio: 16 / 9 !important;
    width: 100%;
    object-fit: cover;
  }
}
</style>
